'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  size: 'small',
  step: 1,
  valueFormatter: function valueFormatter(n) {
    return n;
  },
  withTooltip: false
};